import {
    push
} from 'connected-react-router'
import {
    call,
    put,
    select,
    takeEvery,
} from 'redux-saga/effects';
import {
    selectComposerPost
} from '../../store';
import {
    ActionPayload,
    ActionTypes,
    submitPostSuccess
} from '../../store/composer/actions';
import {
    createPost
} from './service';

export function* submitPost() {
    const post = yield select(selectComposerPost)
    const postURL = yield call(createPost, post)
    yield put(submitPostSuccess(postURL));
}

export function* addPhotoToComposer() {
    yield put(push("/"))
}

export function* composerSaga() {
    yield takeEvery(ActionTypes.POST_SUBMIT_INIT, submitPost);
    yield takeEvery(ActionTypes.ADD_PHOTO_TO_POST, addPhotoToComposer)
}
